export enum InternalStaticImageType {
  Spinner = 'InternalSpinner',
  ThubmnailLoadingBiStatic = 'ThubmnailLoadingBiStatic',
  ExceptionLoadingBi = 'ExceptionLoadingBi',
  LoadingStatic = 'LoadingStatic',
  LoadingImageErrorWebStatic = 'LoadingImageErrorWebStatic',
  ShortcutHome = 'ShortcutHome',
  ShortcutWebtoon = 'ShortcutWebtoon',
  ShortcutWebNovel = 'ShortcutWebNovel',
  ShortcutBook = 'ShortcutBook',
  Shortcut1 = 'Shortcut1',
  Shortcut2 = 'Shortcut2',
  Shortcut3 = 'Shortcut3',
  Shortcut4 = 'Shortcut4',
  Shortcut5 = 'Shortcut5',
  Shortcut6 = 'Shortcut6',
  Shortcut7 = 'Shortcut7',
  Shortcut8 = 'Shortcut8',
  Shortcut9 = 'Shortcut9',
  Shortcut10 = 'Shortcut10',
  Shortcut11 = 'Shortcut11',
  Shortcut12 = 'Shortcut12',
  Shortcut13 = 'Shortcut13',
  Shortcut14 = 'Shortcut14',
  Shortcut15 = 'Shortcut15',
  Shortcut16 = 'Shortcut16',
  Shortcut17 = 'Shortcut17',
  Shortcut18 = 'Shortcut18',
  Shortcut19 = 'Shortcut19',
  Shortcut20 = 'Shortcut20',
  Shortcut21 = 'Shortcut21',
  Shortcut22 = 'Shortcut22',
  Shortcut23 = 'Shortcut23',
  Shortcut24 = 'Shortcut24',
  Shortcut25 = 'Shortcut25',
  Shortcut26 = 'Shortcut26',
  Shortcut27 = 'Shortcut27',
  Shortcut28 = 'Shortcut28',
  Shortcut29 = 'Shortcut29',
  Shortcut30 = 'Shortcut30',
  Shortcut31 = 'Shortcut31',
  Shortcut32 = 'Shortcut32',
  Shortcut33 = 'Shortcut33',
  Shortcut34 = 'Shortcut34',
  Shortcut35 = 'Shortcut35',
  Shortcut36 = 'Shortcut36',
  Shortcut37 = 'Shortcut37',
  Shortcut38 = 'Shortcut38',
  CashBannerHelixStatic = 'CashBannerHelixStatic',
  CashBannerMillionStatic = 'CashBannerMillionStatic',
  CashBannerRecentStatic = 'CashBannerRecentStatic',
  HelixLogoStatic = 'HelixLogoStatic',
  ImgSplashLight = 'ImgSplashLight',
}
